<script>
export default {
    data() {
        return {

        };
    },
    created: function() {

    },
    methods: {
        getApiClasses(){
            return axios.get('/v/classes/getAll');
        },
        getApiTimeTable(className){
            return axios.get('/v/timetable/'+className);
        },
        getNotices(){
            return axios.get('/v/notice/getAll');
        },
        getOneTimePopupModal(){
            return axios.get('/v/popup/getActiveEntries')
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/mlang/shared/servicesMixin.vue